/**
 * Codmonサイドメニューアイテムディレクティブ
 *
 * @description
 * このディレクティブは、サイドメニュー内の個別のメニューアイテムを表示します。
 * UI-Routerのstateに基づくアクティブ状態の判定機能を持ちます。
 *
 * @example
 * // 基本的な使用方法
 * <codmon-sidemenu-item
 *   label="食事チェック"
 *   sref="service.setting_meal"
 *   data-test="meal-setting">
 * </codmon-sidemenu-item>
 *
 * // 通常のリンクとして使用
 * <codmon-sidemenu-item
 *   label="連絡帳アルバム"
 *   href="/memories/settings/photo"
 *   data-test="album-setting">
 * </codmon-sidemenu-item>
 *
 * @property {string} label - メニューアイテムに表示するテキスト
 * @property {string} sref - 遷移先のUI-Router state名
 * @property {string} href - 遷移先のURL（srefの代わりに使用可能）
 * @property {string} [dataTest] - テスト用のdata-test属性値
 */
angular.module('inspinia').directive('codmonSidemenuItem', [
  '$state',
  function ($state) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        // 基本プロパティ
        label: '@', // メニュー項目のラベル
        sref: '@', // ui-srefの値
        href: '@', // 通常のリンクURL
        dataTest: '@', // data-test属性
      },
      templateUrl: `/manage/src/view/directive/codmon-ui/codmon_sidemenu_item.html?${new Date().getTime()}`,
      link($scope) {
        // アクティブ状態の判定
        $scope.isActive = () => {
          const targetState = $scope.sref;
          if (!targetState) return false;

          // 完全一致を試す
          if ($state.is(targetState)) return true;

          // パラメータ付きstateの場合、ベース部分で完全一致を試す
          const baseState = targetState.replace(/\([^)]*\)$/, '');
          return $state.is(baseState);
        };
      },
    };
  },
]);
